var locationDropDowns = (function() {

    var $locationSelect = $('.locations-select');


    var populate = function() {
        var URL = "https://storage.googleapis.com/tcm-coachingmanual-v3.appspot.com/static%20files/locations.data";
        $.getJSON(URL, function(data) {
            $.each(data, function(key, item) {
                $locationSelect.append($('<option>').text(item.name).attr('data-flag', item.icon));
            })
        });
    };


    var updateIcon = function() {
        $locationSelect.on('change', function() {
            var flag = $(this).find(":selected").attr('data-flag').toLowerCase(),
                className = 'flag-icon-' + flag,
                $thisFlag = $locationSelect.parent().find('.flag-icon'),
                findLastClass = $thisFlag.attr('class').split(' ').slice(-1),
                findLastClassToString = findLastClass.toString();

            $('#club_location_country_code').text(flag);
            $thisFlag.removeClass('flag-icon-world').removeClass(findLastClassToString).addClass(className);
        });
    };


    var updateText = function() {
        $locationSelect.on('change', function() {
            var selectedText = $(this).find(":selected").text();
            $(this).siblings('.selected-text').text(selectedText);
        });
    };


    if ($locationSelect.length) {
        updateText();
        populate();
        updateIcon();
    }
})();



// WEBPACK FOOTER //
// ./library/js/modules/location-drop-downs.js